<template>
  <el-select
    v-model="employee_id"
    filterable
    remote
    reserve-keyword
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="handleChange"
    @clear="remoteMethod('')"
    clearable
    class="width100"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{
        item.department_name
      }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "Employeselect",
  props: {
    url: { type: String, default: "/admin/employee/all" },
    placeholder: { type: String, default: "请选择员工" },
    status: { type: Number, default: 1 },
  },
  data() {
    return {
      loading: false,
      options: [],
      employee_id: "",
    };
  },
  methods: {
    reset() {
      this.employee_id = "";
    },
    remoteMethod(query) {
      this.loading = true;
      this.$http
        .get(this.url, {
          params: { name: query, page: 1, count: 100, status:this.status, show_department: 1 },
        })
        .then((res) => {
          this.loading = false;
          if (res.code === 1) {
            this.options = res.data.list ? res.data.list : res.data;
          } else {
            this.options = [];
          }
        });
    },
    handleChange() {
      this.$emit("input", this.employee_id);
      this.$emit("change", this.employee_id);
    },
  },
  created() {
    this.remoteMethod("");
  },
};
</script>

<style lang="scss" scoped>
</style>